import { Injectable, EventEmitter } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Question } from '../interfaces/question';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { QuestionType } from '../enums/question-type.enum';
import { data } from '../../data';
import { FormGroup } from '@angular/forms';
import { NgbDateStruct, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { isNumber, toInteger, padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { AnalyticsService } from '../services/analytics.service'
import { forEach } from '@angular/router/src/utils/collection';
import { BehaviorSubject } from 'rxjs';
import { Step } from '../models/step.model';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operator/first';


@Injectable()
export class QuestionnaireService {
	showErrorOtherIncomes$ = new BehaviorSubject<boolean>(false);
	submitted$ = new BehaviorSubject<boolean>(false);
	currentStepSubject = new BehaviorSubject<string>("user-details");
	asmachtaSubject = new BehaviorSubject<string>("");
	DATA: any = data;
	INITIAL_DATA;
	openTermsOfUse = false;
	lastStepID: string = "";
	phoneNumberSent: boolean = false;
	isLoginAdvisor: boolean = false;
	//lastQuestionID: string = "";
	//lastAnswerID: string = "";//?

	restorePoint: {
		step: any,
		questionID: string
	} = null;

	dataChangedEvent: EventEmitter<any> = new EventEmitter;
	activeStep: any;

	private questionnaire: any;// Question[];
	private activeQuestion: any;
	private isAdvisor: boolean = false;
	private i: any = 0;

	scrollHintVisibleChange: EventEmitter<any> = new EventEmitter<any>();

	constructor(
		private http: HttpClient,
		private router: Router,
		private analyticsService: AnalyticsService,
		private translate: TranslateService,
		private route: ActivatedRoute
	) {
		console.log('QuestionnaireService created here');
		this.INITIAL_DATA = JSON.parse(JSON.stringify(this.DATA));
		this.questionnaire = this.DATA.questionnaire;

		/* Dev Stuff */
		window["mydata"] = data;
		window["clearRestorePoint"] = () => { this.clearRestorePoint; }
		window["getInvalidControl"] = (form) => {
			let formControls = form.controls;
			let controlsNames = Object.keys(formControls)
			let invalidControls = {};
			let hasInvalid = false;

			controlsNames.forEach(controlsName => {
				//check each control here
				// if the child is a formGroup or a formArray
				// you may cast it and check it's subcontrols too

				if (!formControls[controlsName].valid) {
					invalidControls[controlsName] = (formControls[controlsName]);
					hasInvalid = true;
				}
			});

			return (hasInvalid) ? invalidControls : null;
		}
		window["logInvalidControls"] = (form) => {
			let invalidControls = window["getInvalidControl"](form);

			if (invalidControls) {
				console.debug("%c >>> invalid controls: ", "color:white;background:orange;font-weight: bold;padding:0.2em", invalidControls);
			}
		}
	}

	getMaslulim(): Observable<any> {
		return this.http.get("./assets/json-data/maslulim.json")
	}

	initData() {
		this.DATA = JSON.parse(JSON.stringify(this.INITIAL_DATA));
		this.questionnaire = this.DATA.questionnaire;
	}

	setAsmachta(asmachta: string) {
		return this.asmachtaSubject.next(asmachta);
	}

	getAsmachta$() {
		return this.asmachtaSubject.asObservable();
	}

	showErrorMsg(show: boolean) {
		this.showErrorOtherIncomes$.next(show);
	}
	submitForm(isSubmitted: boolean) {
		this.submitted$.next(isSubmitted);
	}
	setScrollHintVisible(visible: boolean) {
		this.scrollHintVisibleChange.emit(visible);
	}

	//for dev only
	performNext00000(current_step, current_question, answer) {
		let key = current_step + "." + current_question;

		let q = {
			"user-details.4": {
				step: 'user-details',
				qid: '5'
			},
			"loan-details.1": {
				step: 'loan-details',
				qid: '2'
			},
			"loan-details.2": {
				step: 'loan-details',
				qid: '3'
			},
			"loan-details.3": {
				step: 'loan-details',
				qid: '4'
			},
			"loan-details.4": {
				step: 'loan-details',
				qid: '5'
			},
			"loan-details.5": {
				step: 'loan-details',
				qid: '6'
			},
			"loan-details.6": {
				step: 'loan-details',
				qid: '7'
			},
			"loan-details.7": {
				step: 'property-details',
				qid: '1'
			},
			"property-details.1": {
				step: 'property-details',
				qid: '2'
			},
			"property-details.2": {
				step: 'property-details',
				qid: '3'
			},
			"property-details.3": {
				step: 'property-details',
				qid: '4'
			},
			"property-details.4": {
				step: 'property-details',
				qid: '5'
			},
			"property-details.5": {
				step: 'borrowers-details',
				qid: '1'
			},
			"borrowers-details.1": {
				step: 'borrowers-details',
				qid: '5'
			},
			"borrowers-details.5": {
				step: 'borrowers-details',
				qid: '7'
			},
			"borrowers-details.7": {
				step: 'borrowers-details',
				qid: '8'
			},
			"borrowers-details.8": {
				step: 'borrowers-details',
				qid: '9'
			},
			"borrowers-details.9": {
				step: 'borrowers-details',
				qid: '10'
			},
			"borrowers-details.10": {
				step: 'borrowers-details',
				qid: '11'
			},
			"borrowers-details.11": {
				step: 'borrowers-details',
				qid: '13'
			},
			"borrowers-details.13": {
				step: 'borrowers-details',
				qid: '14'
			},
			"borrowers-details.14": {
				step: 'borrowers-details',
				qid: '16'
			},
			"borrowers-details.16": {
				step: 'borrowers-details',
				qid: '18'
			},
			"borrowers-details.18": {
				step: 'borrowers-details',
				qid: '20'
			},
			"borrowers-details.20": {
				step: 'borrowers-details',
				qid: '22'
			},
			"borrowers-details.22": {
				step: 'borrowers-details',
				qid: '23'
			},
			"borrowers-details.23": {
				step: 'borrowers-details',
				qid: '29'
			},
			"borrowers-details.29": {
				step: 'borrowers-details',
				qid: '33'
			},
			"borrowers-details.33": {
				step: 'borrowers-details',
				qid: '35'
			},
			"borrowers-details.35": {
				step: 'borrowers-details',
				qid: '36'
			},
			"borrowers-details.36": {
				step: 'borrowers-details',
				qid: '37'
			},
			"borrowers-details.37": {
				step: 'borrowers-details',
				qid: '38'
			},
			"borrowers-details.38": {
				step: 'borrowers-details',
				qid: '39'
			},
			"borrowers-details.39": {
				step: 'borrowers-details',
				qid: '41'
			},
			"borrowers-details.41": {
				step: 'borrowers-details',
				qid: '42'
			},
			"borrowers-details.42": {
				step: 'borrowers-details',
				qid: '46'
			},
			"borrowers-details.46": {
				step: 'liabilities',
				qid: '1'
			},
			"liabilities.1": {
				step: 'liabilities',
				qid: '2'
			},
			"liabilities.2": {
				step: 'liabilities',
				qid: '3'
			},
			"liabilities.3": {
				step: 'liabilities',
				qid: '4'
			},
			"liabilities.4": {
				step: 'liabilities',
				qid: '5'
			},
			"liabilities.5": {
				step: 'financing-sources',
				qid: '1'
			},
			"financing-sources.1": {
				step: 'financing-sources',
				qid: '2'
			}
		}

		return q[key];

	}

	loadQuestionnaire(isReset: boolean): Observable<Question[]> {
		//load from config or DB
		if (isReset) { //TODO:load from config


			this.questionnaire = this.DATA.questionary;
			return Observable.of(this.questionnaire);
		}
		else { //load from DB
			Observable.of(this.questionnaire); //temp
		}

	}

	getStep(stepName: string) {
		return this.questionnaire.steps.filter(step => step.stepName === stepName)[0];
	}

	getStepByID(stepId: string) {
		return this.questionnaire.steps.filter(step => step.stepId == stepId)[0];
	}
	getSteps(): Step[] {
		return this.questionnaire.steps.map((step) => {
			return {
				stepId: step.stepId,
				stepName: step.stepName
			} as Step
		});
	}

	getActiveStep() {
		return this.getStep(this.router.routerState.snapshot.url.split("/")[2]); //TODO:find a better way
	}

	getQuestion(step: any, questionID: string): any {
		return step.questions.filter(question => question.questionId === questionID)[0];
	}

	getBorrowers(): any {
		console.log("++++++++++ getBorrowers");
		let userDetails = this.getStep("user-details");
		let q = this.getQuestion(userDetails, "7");
		let answerData = q.answer["answer-data"];

		let answerDataWithData = answerData.filter(borrow => {
			return borrow.fields[0].answerValue;
		}).map(borrow => {
			// borrow.fields.push({
			// 	answerKey: "borrowerId",
			// 	answerValue: borrow.borrowerId
			// });

			return borrow;;
		});

		//return step["mainBorrow"].questions.filter(question => question.questionId === questionID)[0];

		return answerDataWithData;
	}

	getAnsweredQuestionsForStep(step: any) {
		let answerdQuestions = [];

		for (let i = step.questions.length - 1; i > -1; i--) {//hasAnswer
			if (step.questions[i].hasAnswer) {
				answerdQuestions.push(step.questions[i].questionId);
			}
		}

		console.debug("+-+-+-+-+-+-+-+-+-+-+-+-++-++-  getAnsweredQuestionsForStep()", answerdQuestions)
		return answerdQuestions;
	}


	getAnsweredQuestionsObjForStep(step: any) {
		let answerdQuestions = [];

		for (let i = 0; i < step.questions.length; i++) {//hasAnswer
			if (step.questions[i].hasAnswer) {
				answerdQuestions.push(step.questions[i]);
			}
		}

		console.debug("+-+-+-+-+-+-+-+-+-+-+-+-++-++-  getAnsweredQuestionsForStep()", answerdQuestions)
		return answerdQuestions;
	}

	getAllAnswerdQuestions() {
		let answers = [];
		this.questionnaire.steps.forEach(step => {
			// if (step.reachable) {
			var temp = this.getAnsweredQuestionsObjForStep(step);
			answers = answers.concat(temp);
			// }

		});

		return answers;
	}

	getEstimatedFinishTime(currentStepName: string) {
		let steps = this.questionnaire.steps.sort((obj1, obj2) => {
			if (obj1.stateId > obj2.stateId) {
				return 1;
			} else if (obj1.stateId < obj2.stateId) {
				return -1;
			} else {
				return 0;
			}
		});
		return steps.slice(steps.findIndex(x => x.stepName === currentStepName))
			.map(x => parseInt(x.waitingTime))
			.reduce((sum, num) => sum + num);
	}

	inputSave(resultQuestion, answers) {
		if (this.getBorrowers().length > 0 && (this.i <= (this.getBorrowers().length - 1))) {
			console.log(this.getBorrowers()[this.i].fields[0].answerValue);
			resultQuestion.questionText = resultQuestion.questionText;
			if (resultQuestion.CRM) {
				resultQuestion.CRM.forEach(question => {
					question.q = question.q;
				});
			}
			if (resultQuestion.questionId === ("48-" + (this.i + 1))) {
				this.i++;
			}
		}
		for (let index = 0; index < answers.length; index++) {
			resultQuestion.answer.fields[index].answerValue = answers[index];
		}
	}

	yesNoSave(resultQuestion, answers) {
		if (this.getBorrowers().length > 0 && (this.i <= (this.getBorrowers().length - 1))) {
			console.log(this.getBorrowers()[this.i].fields[0].answerValue);
			resultQuestion.questionText = resultQuestion.questionText;
			if (resultQuestion.questionId === ("48-" + (this.i + 1))) {
				this.i++;
			}
		}
		resultQuestion.selectedAnswer = answers;
	}

	//change
	MoreLessSave(resultQuestion, answers) {
		let currentDate = new Date();
		let userInput = new Date(answers);
		let diff = currentDate.getFullYear() - 1;
		let start = new Date();
		start.setFullYear(diff);
		let moreLess = '';

		if (userInput > start) {
			moreLess = 'LESS';
			resultQuestion.selectedAnswer = moreLess;
			resultQuestion.answersOptions[moreLess].nextQuestion = "37-1";
		}
		else {
			moreLess = 'MORE';
			resultQuestion.selectedAnswer = moreLess;
			if (this.getQuestion(this.getStepByID("4"), "35-1").selectedAnswer[0] === "employee") {
				resultQuestion.answersOptions[moreLess].nextQuestion = "38-1";
			}
			else if (this.getQuestion(this.getStepByID("4"), "35-1").selectedAnswer[0] === "independent") {
				resultQuestion.answersOptions[moreLess].nextQuestion = "41-1";
			}
		}
		resultQuestion.answersOptions[moreLess].answerValue = answers;
	}

	inputArraySave(currentQuestion, answers) {
		if (this.getBorrowers().length > 0 && (this.i <= (this.getBorrowers().length - 1))) {
			console.log(this.getBorrowers()[this.i].fields[0].answerValue);
			currentQuestion.questionText = currentQuestion.questionText;

			if (currentQuestion.CRM) {
				currentQuestion.CRM.forEach(question => {
					question.q = question.q.replace(/XX/g, this.getBorrowers()[this.i].fields[0].answerValue);
				});
			}
			if (currentQuestion.questionId === ("48-" + (this.i + 1))) {
				// for(let qIndex=0; qIndex < currentQuestion.CRM.length; qIndex++) {
				// 	currentQuestion.CRM[qIndex].q = currentQuestion.CRM[qIndex].q.replace(/XX/g,this.getBorrowers()[this.i].fields[0].answerValue); 
				// }
				this.i++;
			}
		}

		//loop through rows
		let tmpFieldsArray = [];
		let tmpFieldObj;

		for (let index = 0; index < answers[0].length; index++) {
			tmpFieldsArray = [];
			tmpFieldObj = null;;

			if (answers[0].length < currentQuestion.answer.fieldsArray.length) {
				currentQuestion.answer.fieldsArray.splice(answers[0].length, currentQuestion.answer.fieldsArray.length - 1);
			}
			//creates data.ts structure with empty values
			for (let indexTmp = 0; indexTmp < currentQuestion.answer.fieldsArray[0].length; indexTmp++) {
				tmpFieldObj = {
					"answerText": currentQuestion.answer.fieldsArray[0][indexTmp].answerText,
					"answerKey": currentQuestion.answer.fieldsArray[0][indexTmp].answerKey,
					"answerValue": ""
				};
				tmpFieldsArray.push(tmpFieldObj);
			}

			let keys = Object.keys(answers[0][0]);
			//loop through fields
			for (let index2 = 0; index2 < keys.length; index2++) {
				if (keys[index2] != "required") {
					tmpFieldsArray[index2].answerValue = answers[0][index][keys[index2]];
				}
			}
			if (index <= currentQuestion.answer.fieldsArray.length - 1) {
				currentQuestion.answer.fieldsArray[index] = tmpFieldsArray;
			}
			else {
				currentQuestion.answer.fieldsArray.push(tmpFieldsArray);
			}
		}
	}

	saveData(currentQuestion, answers) {
		switch (currentQuestion.questionType) {
			case QuestionType[QuestionType.Input]:
				this.inputSave(currentQuestion, answers);
				break;
			case QuestionType[QuestionType.MoreLess]:
				this.MoreLessSave(currentQuestion, answers);
				break;
			case QuestionType[QuestionType.YesNo]:
				this.yesNoSave(currentQuestion, answers);
				break;
			case QuestionType.Custom:
				// resultNavigate = CustomSave();
				break;
			case QuestionType[QuestionType.Borrower]:
				this.borrowerSave(currentQuestion, answers);
				break;
			case QuestionType[QuestionType.InputArray]:
				this.inputArraySave(currentQuestion, answers);
				break;
			default:
				break;
		}
	}

	updateNavigateParam(currentQuestion, answers) {
		// if (!answers || (answers && answers[0] === undefined)) {
		// 	return;
		// }
		let index = currentQuestion.questionId.split("-");
		let currentBorrowerid = index[index.length - 1];

		let borrowers = this.getBorrowers();
		let lastBorrowerId = (borrowers && borrowers.length) ? borrowers[borrowers.length - 1].borrowerId : null;

		let step3 = this.getStepByID("3");
		let step4 = this.getStepByID("4");
		let step3Question4 = this.getQuestion(step3, "4");
		let step3Question4Answer = step3Question4.selectedAnswer;

		if (currentQuestion.questionId === "22" && currentQuestion.selectedAnswer[0] === "NO") {
			let questID = "4";
			if (step4.questions[0].answer.fields[4].answerValue === "בשכירות" || step4.questions[1].selectedAnswer[0] === "YES") {
				questID = "5";
			}
			return {
				"step": this.questionnaire.steps.filter(step => step.stepId === '5')[0],
				"qid": step3Question4Answer[0] === "YES" ? '1' : questID,
			};
		}
		else if (currentQuestion.questionId != '7' && currentQuestion.nextIfHasBorrower && borrowers.length === 0) {
			return {
				"step": this.questionnaire.steps.filter(step => step.stepId === '5')[0],
				"qid": step3Question4Answer[0] === "YES" ? '1' : '4',
			};
		} else if (currentQuestion.isLastQuestionForBorrower && lastBorrowerId === currentBorrowerid) {
			return {
				"step": this.questionnaire.steps.filter(step => step.stepId === '5')[0],
				"qid": step3Question4Answer[0] === "YES" ? '1' : '4',
			};
		} else {
			switch (currentQuestion.questionType) {
				case QuestionType[QuestionType.Input]:
					return {
						"step": this.questionnaire.steps.filter(step => step.stepId === currentQuestion.answer.nextStep)[0],
						"qid": currentQuestion.answer.nextQuestion,
						"isLastQuestion": currentQuestion.answer.isLastQuestion
					};

				case QuestionType[QuestionType.YesNo]:
					return {
						"step": this.questionnaire.steps.filter(step => step.stepId === currentQuestion.answersOptions[answers].nextStep)[0],
						"qid": currentQuestion.answersOptions[answers].nextQuestion,
						"isLastQuestion": currentQuestion.answersOptions[answers].isLastQuestion
					};

				case QuestionType[QuestionType.MoreLess]:
					return {
						"step": this.questionnaire.steps.filter(step => step.stepId === currentQuestion.answersOptions[currentQuestion.selectedAnswer].nextStep)[0],
						"qid": currentQuestion.answersOptions[currentQuestion.selectedAnswer].nextQuestion,
						"isLastQuestion": currentQuestion.answersOptions[currentQuestion.selectedAnswer].isLastQuestion
					};

				case QuestionType.Custom:
					// resultNavigate = CustomSave();
					break;
				case QuestionType[QuestionType.Borrower]:
					return {
						"step": this.questionnaire.steps.filter(step => step.stepId === currentQuestion.answer.nextStep)[0],
						"qid": currentQuestion.answer.nextQuestion,
						"isLastQuestion": currentQuestion.answer.isLastQuestion
					};
				case QuestionType[QuestionType.InputArray]:
					return {
						"step": this.questionnaire.steps.filter(step => step.stepId === currentQuestion.answer.nextStep)[0],
						"qid": currentQuestion.answer.nextQuestion,
						"isLastQuestion": currentQuestion.answer.isLastQuestion
					};
				default:
					console.warn("unknown question type!");
					break;
			}
		}
	}

	saveAndNavigate(current_step, qID, answers) {
		console.debug(">> saveAndNavigate()", current_step, qID, answers);

		let resultNavigate;
		let currentQuestion = this.getQuestion(current_step, qID);

		//if (this.lastQuestionID !== "" && (this.lastQuestionID !== qID || this.lastStepID !== current_step.stepId)) {
		//this.lastStepID > current_step.stepId//???

		if (currentQuestion.isJunction) {
			//remove all answer
			this.reset(current_step.stepId, qID);
			this.dataChangedEvent.emit();
		} else {
			//2.update resultNavigate to lastQuestionID
			//resultNavigate = this.updateNavigateParam(currentQuestion, answers);??
		}
		//}

		//save answer in DATA
		currentQuestion.hasAnswer = true;

		this.saveData(currentQuestion, answers);

		//update resultNavigate
		//if (!resultNavigate) {
		resultNavigate = this.updateNavigateParam(currentQuestion, answers);
		//}
		// if (resultNavigate) {
		if (current_step.stepId != "1" && answers[0] != 'נשוי/ה' && resultNavigate.qid != '6') {
			//set navigation target to restore point if have one
			if (!(current_step.stepId === '2' && currentQuestion.questionId === '6')) {
				if (this.restorePoint && (current_step.stepId !== this.restorePoint.step.stepId || currentQuestion.questionId !== this.restorePoint.questionID)) {
					resultNavigate = {
						step: this.restorePoint.step,
						qid: this.restorePoint.questionID,
						isLastQuestion: false
					};
				}
			}
		}



		if (resultNavigate.isLastQuestion) {
			this.router.navigate(["summarize"]);
		} else {
			//update lastStepID and lastQuestionID and lastAnswerID
			this.lastStepID = resultNavigate.step.stepId;
			//this.lastQuestionID = resultNavigate.qid;

			if (parseInt(this.lastStepID) > parseInt(current_step.stepId)) {
				current_step.completed = true;
			}
			this.setRestorePoint(resultNavigate.step, resultNavigate.qid);
			//this.lastAnswerID = ???

			//navigate to next question
			if (resultNavigate.step && resultNavigate.qid) {
				resultNavigate.step.reachable = true; //can navigate to step
				this.activeQuestion = this.getQuestion(current_step, resultNavigate.qid);
				this.currentStepSubject.next(resultNavigate.step.stepName);
				this.router.navigate(["questionnaire", resultNavigate.step.stepName, resultNavigate.qid]);
			}
		}
		// }
	}

	saveAndNavigateBorrowers(current_step, qID, answers) {
		let isBorrowerQuestion = false;
		let currentQuestion = current_step.questions.filter(question => question.questionId === qID)[0];

		if (!(currentQuestion)) {
			currentQuestion = current_step.otherBorrowsQuestions.questions.filter(question => question.questionId === qID)[0];
			isBorrowerQuestion = true;
		}

		//save answer in DATA
		currentQuestion.hasAnswer = true;
		this.saveData(currentQuestion, answers);

		let resultNavigate = this.updateNavigateParam(currentQuestion, answers);
		//this.lastStepID = resultNavigate.step.stepId;
		//this.lastQuestionID = resultNavigate.qid;
		this.setRestorePoint(resultNavigate.step, resultNavigate.qid);

		if (resultNavigate.step && resultNavigate.qid) {
			this.activeQuestion = this.getQuestion(current_step, resultNavigate.qid);
			this.router.navigate(["questionnaire", resultNavigate.step.stepName, resultNavigate.qid]);
		}
	}

	//reset all questions+answers from fromStepID, fromQuestionID to end
	reset(fromStepID, fromQuestionID?) {
		console.log("reset()", fromStepID, fromQuestionID);

		this.currentStepSubject.next("user-details");
		this.clearRestorePoint();

		let fromStep = this.questionnaire.steps.filter(step => step.stepId === fromStepID)[0];
		let stepIndex = this.questionnaire.steps.indexOf(fromStep);

		if (fromQuestionID) {
			var fromQuestion = fromStep.questions.filter(question => question.questionId === fromQuestionID)[0];
			var fromQuestionIndex = fromStep.questions.indexOf(fromQuestion)
		}

		let fromIndex;

		for (let i = stepIndex; i < this.questionnaire.steps.length; i++) {//loop steps
			let currentStep = this.questionnaire.steps[i];

			currentStep.completed = false;
			currentStep.reachable = false;
			//otherBorrows questions are at last question so always delete
			if (currentStep.otherBorrows) {
				currentStep.otherBorrows = [];
			}

			//make sure work one time
			fromIndex = fromQuestionIndex || 0;
			fromQuestionIndex = 0;

			//assuming questions are sorted
			for (let j = fromIndex; j < currentStep.questions.length; j++) {//loop questions
				let currentQ = currentStep.questions[j];
				currentQ.hasAnswer = false;

				switch (currentQ.questionType) {
					case QuestionType[QuestionType.Input]:
						for (let indexFields = 0; indexFields < currentQ.answer.fields.length; indexFields++) {
							currentQ.answer.fields[indexFields].answerValue = "";
						}
						break;
					case QuestionType[QuestionType.YesNo]:
						currentQ.selectedAnswer = "";
						break;
					case QuestionType[QuestionType.MoreLess]:
						currentQ.selectedAnswer = "";
						break;
					case QuestionType.Custom:
						// resultNavigate = CustomSave();

						break;
					case QuestionType.Borrower:
						//this case don't work!!!
						//currentQ.answer["answer-data"] = [];
						this.resetBorrowerArray(currentQ);
						break;
					default:
						break;
				}
			}
		}
	}

	resetBorrowerArray(currentQ) {
		let data = currentQ.answer['answer-data'];
		data.forEach(borrower => {
			borrower.fields.forEach(field => {
				field.answerValue = null;
			})
		});
	}

	borrowerSave(currentQ, answers) {
		let data = currentQ.answer['answer-data'];
		data.forEach(borrower => {
			let ans = answers[0].filter(ans => {
				return ans.borrowerId === borrower.borrowerId
			})[0];

			if (ans) {
				let keysArr = Object.keys(ans);

				borrower.fields = keysArr.map(f => {
					return {
						answerText: borrower.fields.filter(function (element) {
							if (element.answerKey === f) {
								return element
							}
						})[0] ?
							borrower.fields.filter(function (element) {
								if (element.answerKey === f) {
									return element
								}
							})[0].answerText : "borrowerId",
						answerValue: ans[f],
						answerKey: f
					}
				});
			} else {
				//erasing if no answer
				borrower.fields.forEach(element => {
					element.answerValue = '';
				});
			}
		});
	}

	setRestorePoint(stepObj: any, questionID: string) {
		this.restorePoint = {
			step: stepObj,
			questionID: questionID
		};
	}

	clearRestorePoint() {
		//this.lastStepID = null;//d
		//this.lastQuestionID = null;//d

		this.restorePoint = null;
	}

	clearAllQuestionValidators(controls, qFields, qArrFields?) {
		console.log("clearPreviousQuestionValidators()");

		let keys = Object.keys(qFields);
		let fgControls: any;

		for (let i = 0; i < keys.length; i++) {
			this.setCurrentQuestionValidators(keys[i], controls, qFields, "", qArrFields, true);
		}
	}

	setCurrentQuestionValidators(qID, controls, qFields, stepId, qArrFields?, isClear?) {
		let field;
		let fgControls;
		let incomesQuestionsArr;
		let incomesQuestionsArrwithSource;

		for (let i = 0; i < qFields[qID].length; i++) {
			field = qFields[qID][i];
			if (controls[field.name]) {
				if (field.type && field.name !== 'borrowersArray') {
					if (isClear) {
						controls[field.name].setValidators(null);
						controls[field.name].disable();
					}
					else {
						controls[field.name].enable();
						controls[field.name].setValidators(field.validators);
					}
				}
				else {
					controls[field.name].setValidators(isClear ? null : field.validators);
				}

				controls[field.name].updateValueAndValidity();

				//set validators for FormArray controls
				fgControls = (<FormGroup>controls[field.name]).controls;

				if (qArrFields && qArrFields[qID] && fgControls && fgControls.length > 0) {
					fgControls.forEach(fgC => {
						//console.log(">>>>>>>>>>  FormArray controls", fgC.controls);

						qArrFields[qID].forEach(f => {
							fgC.controls[f.name].setValidators(isClear ? null : f.validators);
							//handle fields date validator inside arrays 
							if (f.type) {
								if (isClear) {
									fgC.controls[f.name].setValidators(null);
									fgC.controls[f.name].disable();
								}
								else {
									fgC.controls[f.name].enable();
									fgC.controls[f.name].setValidators(f.validators);
								}
							}
							fgC.controls[f.name].updateValueAndValidity();

							//incomes amount field is not required if no additional incomes type ---temp
							incomesQuestionsArr = ["4.20", "4.48-1", "4.48-2", "4.48-3", "4.48-4", "4.48-5"];
							if (incomesQuestionsArr.includes(stepId + "." + qID) && fgC.controls['type'].value && fgC.controls['type'].value === 'אין לי הכנסות נוספות') {
								fgC.controls['amount'].setValue(0);
								fgC.controls['amount'].disable();
								fgC.controls['amount'].setValidators(null);
								fgC.controls['amount'].updateValueAndValidity();
							} else if (incomesQuestionsArr.includes(stepId + "." + qID) && fgC.controls['type'].value && fgC.controls['type'].value !== 'אין לי הכנסות נוספות') {
								fgC.controls['amount'].enable();
							}
							//incomes source field is not required if the user don't select אחר type
							incomesQuestionsArrwithSource = ["4.20", "4.48-1", "4.48-2", "4.48-3", "4.48-4", "4.48-5", "6.1"];
							if (incomesQuestionsArrwithSource.includes(stepId + "." + qID) && fgC.controls['type'].value && fgC.controls['type'].value !== 'אחר') {
								fgC.controls['source'].setValidators(null);
								fgC.controls['source'].updateValueAndValidity();
							}
						});
					});
				}
			} else if (!isClear) {
				console.warn("setCurrentQuestionValidators(): missing controll", field.name)
			}
		}
	}

	updateMetaData(current_step, qID, answers) {
		let step1 = this.getStepByID("1");
		let step2 = this.getStepByID("2");
		let step3 = this.getStepByID("3");
		let step4 = this.getStepByID("4");
		let step5 = this.getStepByID("5");
		let currentAnswer = answers[0];

		let isAdvisor = this.getIsAdvisor();

		switch (current_step.stepId + "." + qID) {
			case "1.5":
				if (answers[0] === "נשוי/ה") {
					this.getQuestion(step1, "5").answer.nextQuestion = "7";
				}
				else {
					this.getQuestion(step1, "5").answer.nextQuestion = "6";
				}
				if (answers[0] === "גרוש/ה") {
					this.getQuestion(step4, "1").answer.nextQuestion = "4.1";
				}
				break;
			case "2.2.0":
				this.getQuestion(current_step, "2.0").selectedAnswer = answers;
				break;
			case "2.1":
				if (isAdvisor) {
					this.getQuestion(current_step, "2.1").answer.nextStep = "2";
					this.getQuestion(current_step, "2.1").answer.nextQuestion = "2.4";
					this.getQuestion(current_step, "2.0").answersOptions["NO"].nextQuestion = "2.4";
					this.getQuestion(current_step, "2.0").answersOptions["NO"].nextStep = "2";
				}
				// if(isAdvisor){
				// 	this.getQuestion(current_step, "7").answer.nextStep = "2";
				// 	this.getQuestion(current_step, "7").answer.nextQuestion = "8";
				//  	this.getQuestion(current_step, "6").answersOptions["NO"].nextStep = "2";
				// 	this.getQuestion(current_step, "6").answersOptions["NO"].nextQuestion = "8";
				// 	this.getQuestion(current_step, "5").answersOptions["NO"].nextStep = "2";
				// 	this.getQuestion(current_step, "5").answersOptions["NO"].nextQuestion = "8";
				// 	this.getQuestion(current_step, "5").answersOptions["YES"].nextStep = "2";
				// 	this.getQuestion(current_step, "5").answersOptions["YES"].nextQuestion = "8";

				// }
				if (currentAnswer === "1") {
					// 3.1->3.2->3.4->3.5     3.2 only if 2.6==no
					// 3.1->3.4->3.5		  without 3.2 if 2.6==yes

					//howMuchYouNeed
					this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "2";
					//current_step.questions[3].answersOptions["NO"].nextStep = "2";
					this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "6";//step 2.3 NO -> step 2.6
					//current_step.questions[3].answersOptions["NO"].nextQuestion = "6";
					//haveOneYet
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "2";
					// //current_step.questions[4].answersOptions["NO"].nextStep = "2";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "5";//step 2.4 NO -> step 2.6
					//current_step.questions[4].answersOptions["NO"].nextQuestion = "6";
					//doYouIntendToSellIt
					this.getQuestion(current_step, "5").answersOptions["YES"].nextStep = "2";
					//current_step.questions[5].answersOptions["YES"].nextStep = "2";
					this.getQuestion(current_step, "5").answersOptions["YES"].nextQuestion = "6";//step 2.5 YES -> step 2.6
					//current_step.questions[5].answersOptions["YES"].nextQuestion = "6";
					this.getQuestion(current_step, "5").answersOptions["NO"].nextStep = "2";
					//current_step.questions[5].answersOptions["NO"].nextStep = "2";
					this.getQuestion(current_step, "5").answersOptions["NO"].nextQuestion = "6";//step 2.5 NO -> step 2.6
					//current_step.questions[5].answersOptions["NO"].nextQuestion = "6";

					this.getQuestion(step3, "4").answersOptions["YES"].nextStep = "3";
					//step3.questions[3].answersOptions["YES"].nextStep = "3";
					this.getQuestion(step3, "4").answersOptions["YES"].nextQuestion = "5";//step 3.4 YES -> step 3.5
					//step3.questions[3].answersOptions["YES"].nextQuestion = "5";
					this.getQuestion(step3, "4").answersOptions["NO"].nextStep = "3";
					//step3.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(step3, "4").answersOptions["NO"].nextQuestion = "5";//step 3.4 NO -> step 3.5
					//step3.questions[3].answersOptions["NO"].nextQuestion = "5";
					//step3.questions[0].answer.nextQuestion = "3";
					//let step3 = this.questionnaire.getStepByID("3");
				}
				if (currentAnswer === "2") {
					// 3.1->3.2->3.5

					this.getQuestion(step3, "1").answer.nextQuestion = "2";//step 3.1 -> step 3.2
					//step3.questions[0].answer.nextQuestion = "2";
					// if(isAdvisor){
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "8";// 2.3 NO => 3.1
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "8";// 2.4 NO => 3.1
					// }
					// else{
					this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "3";
					//current_step.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "1";// 2.3 NO => 3.1
					//current_step.questions[3].answersOptions["NO"].nextQuestion = "1";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "3";
					// //current_step.questions[4].answersOptions["NO"].nextStep = "3";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "1";// 2.4 NO => 3.1
					//current_step.questions[4].answersOptions["NO"].nextQuestion = "1";
					// }
					this.getQuestion(step3, "4").answersOptions["YES"].nextStep = "3";
					//step3.questions[3].answersOptions["YES"].nextStep = "3";
					this.getQuestion(step3, "4").answersOptions["YES"].nextQuestion = "5";//step 3.4 YES -> step 3.5
					//step3.questions[3].answersOptions["YES"].nextQuestion = "5";
					this.getQuestion(step3, "4").answersOptions["NO"].nextStep = "3";
					//step3.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(step3, "4").answersOptions["NO"].nextQuestion = "5";//step 3.4 NO -> step 3.5
					//step3.questions[3].answersOptions["NO"].nextQuestion = "5";
				}
				if (currentAnswer === "5") {
					//3.1->3.3->3.3.1->3.4->3.5

					this.getQuestion(step3, "2").answer.nextQuestion = "4";// 3.2 -> 3.4 ???????? no 3.2 in selfConstructor
					//step3.questions[1].answer.nextQuestion = "4";
					this.getQuestion(step3, "3").answer.nextQuestion = "3.1";// 3.3 -> 3.3.1
					//step3.questions[2].answer.nextQuestion = "4";


					this.getQuestion(step3, "1").answer.nextQuestion = "3";// step 3.1 -> 3.3
					//step3.questions[0].answer.nextQuestion = "3";
					this.getQuestion(step3, "4").answersOptions["YES"].nextStep = "3";
					//step3.questions[3].answersOptions["YES"].nextStep = "3";
					this.getQuestion(step3, "4").answersOptions["YES"].nextQuestion = "5";//step 3.4 YES -> step 3.5
					//step3.questions[3].answersOptions["YES"].nextQuestion = "5";
					this.getQuestion(step3, "4").answersOptions["NO"].nextStep = "3";
					//step3.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(step3, "4").answersOptions["NO"].nextQuestion = "5";//step 3.4 NO -> step 3.5
					//step3.questions[3].answersOptions["NO"].nextQuestion = "5";

					// if(isAdvisor){
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "8";// 2.3 NO => 3.1
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "8";// 2.4 NO => 3.1
					// }
					// else{
					this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "3";
					//current_step.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "1";// 2.3 NO => 3.1
					//current_step.questions[3].answersOptions["NO"].nextQuestion = "1";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "3";
					// //current_step.questions[4].answersOptions["NO"].nextStep = "3";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "1";// 2.4 NO => 3.1
					//current_step.questions[4].answersOptions["NO"].nextQuestion = "1";
					// }
				}
				if (currentAnswer === "10") {
					//3.1->3.2->3.3.2->3.3.3->3.5 		3.3.3 only if 3.3.2 === YES
					//3.1->3.2->3.3.2->3.5				wuthout 3.3.3 if 3.3.2 === NO

					this.getQuestion(step3, "1").answer.nextQuestion = "2";//step 3.1 -> step 3.2
					//step3.questions[0].answer.nextQuestion = "2";
					// if(isAdvisor){
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "8";// 2.3 NO => 3.1
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "8";// 2.4 NO => 3.1
					// }
					// else{
					this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "3";
					//current_step.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "1";// 2.3 NO => 3.1
					//current_step.questions[3].answersOptions["NO"].nextQuestion = "1";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "3";
					// //current_step.questions[4].answersOptions["NO"].nextStep = "3";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "1";// 2.4 NO => 3.1
					//current_step.questions[4].answersOptions["NO"].nextQuestion = "1";
					// }

					this.getQuestion(step3, "4").answersOptions["YES"].nextStep = "3";
					//step3.questions[3].answersOptions["YES"].nextStep = "3";
					this.getQuestion(step3, "4").answersOptions["YES"].nextQuestion = "5";//step 3.4 YES -> step 3.5
					//step3.questions[3].answersOptions["YES"].nextQuestion = "5";
					this.getQuestion(step3, "4").answersOptions["NO"].nextStep = "3";
					//step3.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(step3, "4").answersOptions["NO"].nextQuestion = "5";//step 3.4 NO -> step 3.5
					//step3.questions[3].answersOptions["NO"].nextQuestion = "5";

					this.getQuestion(step3, "2").answer.nextQuestion = "3.2";//step 3.2 -> step 3.3.2
				}
				if (currentAnswer === "7") {
					//3.1->3.2->3.4->4.1

					this.getQuestion(step3, "2").answer.nextQuestion = "4";// 3.2 -> 3.4
					//step3.questions[1].answer.nextQuestion = "4";
					this.getQuestion(step3, "3").answer.nextQuestion = "4";// 3.3 -> 3.4 ???????? no 3.3 in expansion
					//step3.questions[2].answer.nextQuestion = "4";

					this.getQuestion(step3, "1").answer.nextQuestion = "2";//step 3.1 -> step 3.2
					//step3.questions[0].answer.nextQuestion = "2";
					// if(isAdvisor){
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "8";// 2.3 NO => 3.1
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "8";// 2.4 NO => 3.1
					// }
					// else{
					this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "3";
					//current_step.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "1";// 2.3 NO => 3.1
					//current_step.questions[3].answersOptions["NO"].nextQuestion = "1";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "3";
					// //current_step.questions[4].answersOptions["NO"].nextStep = "3";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "1";// 2.4 NO => 3.1
					//current_step.questions[4].answersOptions["NO"].nextQuestion = "1";
					// }

					this.getQuestion(step3, "4").answersOptions["YES"].nextStep = "3";
					//step3.questions[3].answersOptions["YES"].nextStep = "4";
					this.getQuestion(step3, "4").answersOptions["YES"].nextQuestion = "5";
					//step3.questions[3].answersOptions["YES"].nextQuestion = "1";
					this.getQuestion(step3, "4").answersOptions["NO"].nextStep = "3";
					//step3.questions[3].answersOptions["NO"].nextStep = "4";
					this.getQuestion(step3, "4").answersOptions["NO"].nextQuestion = "5";
					//step3.questions[3].answersOptions["NO"].nextQuestion = "1";
				}
				if (currentAnswer === "11") {
					//3.1->3.2->3.4->4.1

					this.getQuestion(step3, "2").answer.nextQuestion = "4";// 3.2 -> 3.4
					//step3.questions[1].answer.nextQuestion = "4";
					this.getQuestion(step3, "3").answer.nextQuestion = "4";// 3.3 -> 3.4 ???????? no 3.3 in 11
					//step3.questions[2].answer.nextQuestion = "4";


					this.getQuestion(step3, "1").answer.nextQuestion = "2";//step 3.1 -> step 3.2
					//step3.questions[0].answer.nextQuestion = "2";
					// if(isAdvisor){
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "8";// 2.3 NO => 3.1
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "8";// 2.4 NO => 3.1
					// }
					// else{
					this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "3";
					//current_step.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "1";// 2.3 NO => 3.1
					//current_step.questions[3].answersOptions["NO"].nextQuestion = "1";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "3";
					// //current_step.questions[4].answersOptions["NO"].nextStep = "3";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "1";// 2.4 NO => 3.1
					//current_step.questions[4].answersOptions["NO"].nextQuestion = "1";
					// }

					this.getQuestion(step3, "4").answersOptions["YES"].nextStep = "3";
					//step3.questions[3].answersOptions["YES"].nextStep = "4";
					this.getQuestion(step3, "4").answersOptions["YES"].nextQuestion = "5";//step 3.4 YES -> step 4.1
					//step3.questions[3].answersOptions["YES"].nextQuestion = "1";
					this.getQuestion(step3, "4").answersOptions["NO"].nextStep = "3";
					//step3.questions[3].answersOptions["NO"].nextStep = "4";
					this.getQuestion(step3, "4").answersOptions["NO"].nextQuestion = "5";//step 3.4 NO -> step 4.1
					//step3.questions[3].answersOptions["NO"].nextQuestion = "1";
				}
				if (currentAnswer === "17") {
					//3.1->3.2->3.4->4.1

					this.getQuestion(step3, "2").answer.nextQuestion = "4";// 3.2 -> 3.4
					//step3.questions[1].answer.nextQuestion = "4";
					this.getQuestion(step3, "3").answer.nextQuestion = "4";// 3.3 -> 3.4 ???????? no 3.3 in 11
					//step3.questions[2].answer.nextQuestion = "4";


					this.getQuestion(step3, "1").answer.nextQuestion = "2";//step 3.1 -> step 3.2
					//step3.questions[0].answer.nextQuestion = "2";
					// if(isAdvisor){
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "8";// 2.3 NO => 3.1
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "2";
					// 	this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "8";// 2.4 NO => 3.1
					// }
					// else{
					this.getQuestion(current_step, "3").answersOptions["NO"].nextStep = "3";
					//current_step.questions[3].answersOptions["NO"].nextStep = "3";
					this.getQuestion(current_step, "3").answersOptions["NO"].nextQuestion = "1";// 2.3 NO => 3.1
					//current_step.questions[3].answersOptions["NO"].nextQuestion = "1";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextStep = "3";
					// //current_step.questions[4].answersOptions["NO"].nextStep = "3";
					// this.getQuestion(current_step, "4").answersOptions["NO"].nextQuestion = "1";// 2.4 NO => 3.1
					//current_step.questions[4].answersOptions["NO"].nextQuestion = "1";
					// }

					this.getQuestion(step3, "4").answersOptions["YES"].nextStep = "3";
					//step3.questions[3].answersOptions["YES"].nextStep = "4";
					this.getQuestion(step3, "4").answersOptions["YES"].nextQuestion = "5";//step 3.4 YES -> step 4.1
					//step3.questions[3].answersOptions["YES"].nextQuestion = "1";
					this.getQuestion(step3, "4").answersOptions["NO"].nextStep = "3";
					//step3.questions[3].answersOptions["NO"].nextStep = "4";
					this.getQuestion(step3, "4").answersOptions["NO"].nextQuestion = "5";//step 3.4 NO -> step 4.1
					//step3.questions[3].answersOptions["NO"].nextQuestion = "1"; 
				}
				break;
			case "2.2":
				if (isAdvisor) {
					if (this.getQuestion(current_step, "1").selectedAnswer[0] === "11") {
						this.getQuestion(current_step, "2.1").answer.nextStep = "2";
						this.getQuestion(current_step, "2.1").answer.nextQuestion = "2.4";
						this.getQuestion(current_step, "2.0").answersOptions["NO"].nextQuestion = "2.4";
						this.getQuestion(current_step, "2.0").answersOptions["NO"].nextStep = "2";

					}
					else {
						this.getQuestion(current_step, "2.1").answer.nextStep = "2";
						this.getQuestion(current_step, "2.1").answer.nextQuestion = "2.2";
						this.getQuestion(current_step, "2.0").answersOptions["NO"].nextQuestion = "2.2";
						this.getQuestion(current_step, "2.0").answersOptions["NO"].nextStep = "2";
					}
				}
				else {
					if (this.getQuestion(current_step, "1").selectedAnswer[0] === "11") {
						this.getQuestion(current_step, "2.1").answer.nextStep = "2";
						this.getQuestion(current_step, "2.1").answer.nextQuestion = "3";
						this.getQuestion(current_step, "2.0").answersOptions["NO"].nextQuestion = "3";
						this.getQuestion(current_step, "2.0").answersOptions["NO"].nextStep = "2";
					}
					else {
						this.getQuestion(current_step, "2.1").answer.nextStep = "2";
						this.getQuestion(current_step, "2.1").answer.nextQuestion = "2.2";
						this.getQuestion(current_step, "2.0").answersOptions["NO"].nextQuestion = "2.2";
						this.getQuestion(current_step, "2.0").answersOptions["NO"].nextStep = "2";
						this.getQuestion(current_step, "2.2").answer.nextStep = "2";
						this.getQuestion(current_step, "2.2").answer.nextQuestion = "3";
					}
				}
			case "2.6":
				if (answers[0] === "NO" && this.getQuestion(current_step, "1").selectedAnswer[0] === "1") {
					this.getQuestion(step3, "1").answer.nextStep = "3";
					//step3.questions[0].answer.nextStep = "3";
					this.getQuestion(step3, "1").answer.nextQuestion = "2";
					//step3.questions[0].answer.nextQuestion = "2";
				}
				else if ((answers[0] === "YES" && this.getQuestion(current_step, "1").selectedAnswer[0] === "1")) {
					this.getQuestion(step3, "1").answer.nextStep = "3";
					//step3.questions[0].answer.nextStep = "3";
					this.getQuestion(step3, "1").answer.nextQuestion = "4";
					//step3.questions[0].answer.nextQuestion = "4";
				}
				if (answers[0] === "YES") {
					// this.getQuestion(step2, "7").answer.nextStep = "3";
					// this.getQuestion(step2, "7").answer.nextQuestion = "2";
					this.getQuestion(step2, "6").answersOptions["YES"].nextStep = "2";
					this.getQuestion(step2, "6").answersOptions["YES"].nextQuestion = "7";
				}
				if (answers[0] === "NO") {
					this.getQuestion(step2, "6").answersOptions["NO"].nextStep = "3";
					this.getQuestion(step2, "6").answersOptions["NO"].nextQuestion = "1";
				}
				break;
			case "3.4":
				break;
			case "4.1":
				//clean up array of Q5
				if (this.getQuestion(step5, "5").answer.fieldsArray &&
					this.getQuestion(step5, "5").answer.fieldsArray.length > 0) {
					this.getQuestion(step5, "5").answer.fieldsArray.splice(1);
				}
				if (this.getQuestion(step1, "6").selectedAnswer[0] === "NO" && this.getQuestion(step3, "4").selectedAnswer[0] === "YES") {
					this.getQuestion(step4, "20").answer.nextStep = "5";
					this.getQuestion(step4, "20").answer.nextQuestion = "1";
					this.getQuestion(step4, "20.1").answersOptions["under"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["middle"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["over"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["under"].nextQuestion = "1";
					this.getQuestion(step4, "20.1").answersOptions["middle"].nextQuestion = "1";
					this.getQuestion(step4, "20.1").answersOptions["over"].nextQuestion = "1";
				}
				if (this.getQuestion(step1, "6").selectedAnswer[0] === "NO" &&
					(this.getQuestion(step3, "4").selectedAnswer[0] === "NO" || !(this.getQuestion(step3, "4").selectedAnswer[0]))) {
					this.getQuestion(step4, "20").answer.nextStep = "5";
					this.getQuestion(step4, "20").answer.nextQuestion = "4";
					this.getQuestion(step4, "20.1").answersOptions["under"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["middle"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["over"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["under"].nextQuestion = "4";
					this.getQuestion(step4, "20.1").answersOptions["middle"].nextQuestion = "4";
					this.getQuestion(step4, "20.1").answersOptions["over"].nextQuestion = "4";
				}
				// if(answers[3] === "נשוי"){
				// 	this.getQuestion(step4, "20").answer.nextQuestion = "23";
				// 	//step4.questions[14].answer.nextQuestion = "23";
				// 	//step4.questions[15].selectedAnswer = "YES";
				// 	// if (step4.questions[16].answer['answer-data']) {
				// 	// 	step4.questions[16].answer['answer-data'][0].fields[4].answerValue = "בן/בת זוג";
				// 	// 	//step4.questions[16].answer['answer-data'][0].fields.required = true;
				// 	// }
				// } else {
				// 	this.getQuestion(step4, "20").answer.nextQuestion = "22";
				// 	//step4.questions[14].answer.nextQuestion = "22";
				// 	//step4.questions[15].selectedAnswer = "";
				// }
				//if(answers[3] === "גרוש"){
				//this.getQuestion(step4, "1").answer.nextQuestion = "4.1";
				//step4.questions[0].answer.nextQuestion = "4.1";
				//step4.questions[1].selectedAnswer = "";

				//step5.questions[2].answer.nextQuestion = "4";
				//step5.questions[3].selectedAnswer = "YES";
				//step4.questions[14].answersOptions["NO"].nextQuestion = "5";
				//} else {
				// this.getQuestion(step4, "1").answer.nextQuestion = "5";
				//step4.questions[0].answer.nextQuestion = "5";
				//step4.questions[1].selectedAnswer = "";

				//step5.questions[2].answer.nextQuestion = "4";
				//step5.questions[3].selectedAnswer = "";
				//step4.questions[14].answersOptions["NO"].nextQuestion = "4";
				//}
				if (answers[4] === "בשכירות") {
					this.getQuestion(step5, "3").answer.nextQuestion = "5";
					//step5.questions[2].answer.nextQuestion = "5";
					if (this.getQuestion(step5, "5").answer.fieldsArray) {
						this.getQuestion(step5, "5").answer.fieldsArray[0][0].answerValue = "שכר דירה";
						//step5.questions[4].answer.fieldsArray[0][0].answerValue = "שכר דירה";
						this.getQuestion(step5, "5").answer.fieldsArray[0].required = true;
						//step5.questions[4].answer.fieldsArray[0].required = true;
					}
				} else {
					this.getQuestion(step5, "3").answer.nextQuestion = "4";

					//step5.questions[2].answer.nextQuestion = "4";
					this.getQuestion(step5, "5").answer.fieldsArray[0][0].answerValue = "";
					//step5.questions[4].answer.fieldsArray[0][0].answerValue = "";
					this.getQuestion(step5, "5").answer.fieldsArray[0].required = false;
					//step5.questions[4].answer.fieldsArray[0].required = false;
				}
				break;
			case "4.4.1":
				//clean up array of Q5

				if (this.getQuestion(step5, "5").answer.fieldsArray &&
					this.getQuestion(step5, "5").answer.fieldsArray.length > 0) {
					this.getQuestion(step5, "5").answer.fieldsArray.splice(1);
				}
				if (this.getQuestion(step1, "6").selectedAnswer[0] === "NO" &&
					(this.getQuestion(step3, "4").selectedAnswer[0] === "NO" || !(this.getQuestion(step3, "4").selectedAnswer[0]))
					&& (answers[0] === "NO")) {
					this.getQuestion(step4, "20").answer.nextStep = "5";
					this.getQuestion(step4, "20").answer.nextQuestion = "4";
					this.getQuestion(step4, "20.1").answersOptions["under"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["middle"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["over"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["under"].nextQuestion = "4";
					this.getQuestion(step4, "20.1").answersOptions["middle"].nextQuestion = "4";
					this.getQuestion(step4, "20.1").answersOptions["over"].nextQuestion = "4";
					if (step4.questions[0].answer.fields[1].answerValue === "בשכירות") {
						this.getQuestion(step5, "5").answer.fieldsArray[0][0].answerValue = "שכר דירה";
						this.getQuestion(step5, "5").answer.fieldsArray[0].required = true;
						this.getQuestion(step4, "20.1").answersOptions["under"].nextQuestion = "5";
						this.getQuestion(step4, "20.1").answersOptions["middle"].nextQuestion = "5";
						this.getQuestion(step4, "20.1").answersOptions["over"].nextQuestion = "5";
					}

				}
				if (this.getQuestion(step1, "6").selectedAnswer[0] === "NO" &&
					(this.getQuestion(step3, "4").selectedAnswer[0] === "NO" || !(this.getQuestion(step3, "4").selectedAnswer[0]))
					&& (answers[0] === "YES")) {
					this.getQuestion(step4, "20").answer.nextStep = "5";
					this.getQuestion(step4, "20").answer.nextQuestion = "3.1";
					this.getQuestion(step4, "20.1").answersOptions["under"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["middle"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["over"].nextStep = "5";
					this.getQuestion(step4, "20.1").answersOptions["under"].nextQuestion = "3.1";
					this.getQuestion(step4, "20.1").answersOptions["middle"].nextQuestion = "3.1";
					this.getQuestion(step4, "20.1").answersOptions["over"].nextQuestion = "3.1";
					if (step4.questions[0].answer.fields[1].answerValue === "בשכירות") {
						this.getQuestion(step5, "5").answer.fieldsArray[0][0].answerValue = "שכר דירה";
						this.getQuestion(step5, "5").answer.fieldsArray[0].required = true;
						this.getQuestion(step5, "3.1").answer.nextQuestion = "5";

					}
				}
				if (answers[0] === "YES") {
					this.getQuestion(step5, "3").answer.nextQuestion = "5";
					//step5.questions[2].answer.nextQuestion = "5";
					// //if the first is not empty nedd a second
					// if (step4.questions[0].answer.fields[1].answerValue === "בשכירות") {
					//push deep copy of new one
					// let tmp = JSON.parse(JSON.stringify(step5.questions[4].answer.fieldsArray[0]));
					// tmp[0].answerValue = "מזונות";
					// tmp.required = true;
					// step5.questions[6].answer.fieldsArray.push(tmp);
					// } else {
					step5.questions[6].answer.fieldsArray[0][0].answerValue = "מזונות";
					step5.questions[6].answer.fieldsArray[0].required = true;
					if (step4.questions[0].answer.fields[1].answerValue === "בשכירות") {
						this.getQuestion(step5, "5").answer.fieldsArray[1][0].answerValue = "שכר דירה";
						this.getQuestion(step5, "5").answer.fieldsArray[1].required = true;
					}
					// }

					//if (step5.questions[4].answer.fieldsArray) {
					//	step5.questions[4].answer.fieldsArray[0][0].answerValue = "מזונות";
					//}
				} else {
					this.getQuestion(step5, "3").answer.nextQuestion = "4";
					step5.questions[2].answer.nextQuestion = "4";
					if (step4.questions[0].answer.fields[1].answerValue === "בשכירות") {
						this.getQuestion(step5, "5").answer.fieldsArray[0][0].answerValue = "שכר דירה";
						this.getQuestion(step5, "5").answer.fieldsArray[0].required = true;
						this.getQuestion(step5, "3").answer.nextQuestion = "5";
						step5.questions[2].answer.nextQuestion = "5";
					} else {
						step5.questions[6].answer.fieldsArray[0][0].answerValue = "";
						step5.questions[6].answer.fieldsArray[0].required = false;
					}
				}
				if (answers[0] === "YES") {
					this.getQuestion(step5, "3").answer.nextQuestion = "3.1";
				}
				break;
			case "4.20":
				let flag = 0;
				answers[0].forEach(f => {
					if (f.type === "מקום עבודה נוסף") {
						this.getQuestion(step4, "20").answer.nextStep = "4";
						this.getQuestion(step4, "20").answer.nextQuestion = "20.1";
						flag = 1;
					}
				});
				if (flag === 0) {
					if (this.getQuestion(step1, "6").selectedAnswer[0] === "NO" &&
						(this.getQuestion(step3, "4").selectedAnswer[0] === "NO" || !(this.getQuestion(step3, "4").selectedAnswer[0]))
						&& (this.getQuestion(step4, "4.1").selectedAnswer[0] === "YES")) {
						this.getQuestion(step4, "20").answer.nextStep = "5";
						this.getQuestion(step4, "20").answer.nextQuestion = "3.1";
					}
					if (this.getQuestion(step1, "6").selectedAnswer[0] === "NO" &&
						(this.getQuestion(step3, "4").selectedAnswer[0] === "NO" || !(this.getQuestion(step3, "4").selectedAnswer[0]))
						&& (this.getQuestion(step4, "4.1").selectedAnswer[0] === "NO")) {
						this.getQuestion(step4, "20").answer.nextStep = "5";
						this.getQuestion(step4, "20").answer.nextQuestion = "4";
					}
					if (this.getQuestion(step1, "6").selectedAnswer[0] === "NO" &&
						(this.getQuestion(step3, "4").selectedAnswer[0] === "NO" || !(this.getQuestion(step3, "4").selectedAnswer[0]))) {
						this.getQuestion(step4, "20").answer.nextStep = "5";
						this.getQuestion(step4, "20").answer.nextQuestion = "4";
					}
				}
				break;
			case "5.3.2":
				step5.questions[6].answer.fieldsArray[0][2].answerValue = step5.questions[3].answer.fields[0].answerValue;
				break;

			default:
				break;
		}
	}

	customFormat(value: string): NgbDateStruct {
		//from string to ngbDateStruct
		if (value) {
			const dateParts = value.trim().split('/');
			return { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2]) };
		}
		return null;
	}
	customFormatNgbDateStructToString(value: NgbDateStruct): string {
		//from ngbDateStruct to string
		if (value) {
			let newDay: string = value.day < 10 ? '0' + value.day : value.day.toString();
			let newMonth: string = value.month < 10 ? '0' + value.month : value.month.toString();

			return newDay + '/' + newMonth + '/' + value.year;
		}
		return null;
	}

	customParse(date: NgbDateStruct): string {
		return date ? date.day + '/' + date.month + '/' + date.year : '';
	}

	getRestorePoint() {
		return Object.assign({}, this.restorePoint);
	}

	sendGA(stepObj?: any, qid?: string, values?: any) {
		// if (values && values[0]) 
		// {
		if (qid !== '4') {
			this.phoneNumberSent = false;
		}
		if (stepObj !== undefined) {
			let question;
			let step;
			if (values.type !== 'termOfUseFinal') {
				question = stepObj.questions.filter(q => { return q.questionId === qid })[0];
				step = "שלב" + " " + stepObj.stepId + " - " + stepObj.stepTitle;
			}
			//action
			if (values.type === 'otp' || values.type === 'termOfUse' || (qid === '7' && values.type === 'summarize') || values.type === "termOfUseFinal") {
				if (values.type === 'termOfUseFinal') {
					step = "שלב" + " " + stepObj.stepId + " - " + stepObj.stepTitle;
				}
				let label = values.text; //text
				this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", step, label);
			}
			else {
				if (question.CRM) {
					if (typeof (values[0]) !== 'string' && typeof (values[0]) !== 'object' && typeof (values[0]) !== 'number') {
						for (let i = 0; i < values[0].length; i++) {
							question.CRM.forEach(qu => {
								let label = qu.q + " - המשך";
								this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", step, label);
							});
						}
					}
					else {
						if (!this.phoneNumberSent) {
							question.CRM.forEach(qu => {
								let label = qu.q + " - המשך";
								this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", step, label);
							});
							if (qid === '4') {
								this.phoneNumberSent = true;
							}
						}
					}
				} else {
					let label = "";
					if (question.questionType === "YesNo") {
						label = question.questionText + " - " + question.answersOptions[values[0]].answerText;
					}
					else {
						label = question.questionText + " - המשך";
					}
					this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", step, label);
				}

			}

		}
		// else{
		// 	if(values.type === 'login-otp'){
		// 		let step = "שלב" + " " + "login" + " - " + this.translate.instant('process-save.btn-proceed');
		// 		let label = values.text; //text
		// 		this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", step, label);
		// 	}

		// }
	}

	setIsAdvisor(isAdvisor: boolean) {
		this.isAdvisor = isAdvisor;
	}

	getIsAdvisor() {
		return this.isAdvisor;
	}
}


// WEBPACK FOOTER //
// ./src/app/services/questionnaire.service.ts